import _ from 'lodash';

_.mixin({
  mergeByKey: function (overrideArr, baseArr, key) {
    const dictionary = {};
    baseArr.forEach(element => {
      dictionary[element[key]] = element;
    });
    overrideArr.forEach(element => {
      dictionary[element[key]] = _.merge(dictionary[element[key]], element);
    });

    return Object.values(dictionary);
  },
});
